module.exports = __webpack_public_path__ + "lender-default.caaa764f650236f8d324e755815eb9fc.png";